import styled from "styled-components";

import {
  alpha,
  bp,
  flexColumn,
  flexSpBetween,
  media,
  rem,
} from "@styles/Utilities.styled";


export const StyledResourceManagement = styled.div`
  h1 {
    font-weight: 500;
    font-size: ${rem(20)};
  }
  
  padding-bottom: ${rem(150)};
`;
